import React, { Component } from 'react';
import Slider from 'react-slick';

class SlickSlider extends Component{
	render(){
		// Default settings to the slider
		// but we can overwrite it using Object.assign
		const defaultSettings = Object.assign({
			dots: false,
			infinite: true,
			speed: 500,
			autoplay: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false
		}, this.props.sliderSettings || {} );

		// Ability to add css classes to the slider div
		const className = this.props.className || '';

		const sliderContent = this.props.sliderContent;

		if(sliderContent === undefined || sliderContent.length === 0){
			return null;
		}

		return (
			<Slider {...defaultSettings} className={className}>
				{ sliderContent }
			</Slider>
		);
	}
}

export default SlickSlider;


// WEBPACK FOOTER //
// ./src/components/common/SlickSlider.js